export const dataUploadConstants = {
     DATA_UPLOAD_DATA_TEMPLATE_LIST_REQUEST:
          "DATA_UPLOAD_DATA_TEMPLATE_LIST_REQUEST",
     DATA_UPLOAD_DATA_TEMPLATE_LIST_COMPLETE:
          "DATA_UPLOAD_DATA_TEMPLATE_LIST_COMPLETE",

     DATA_UPLOAD_LIST_REQUEST: "DATA_UPLOAD_LIST_REQUEST",
     DATA_UPLOAD_LIST_COMPLETE: "DATA_UPLOAD_LIST_COMPLETE",

     DATA_UPLOAD_LIST_SILENT_REQUEST: "DATA_UPLOAD_LIST_SILENT_REQUEST",
     DATA_UPLOAD_LIST_SILENT_COMPLETE: "DATA_UPLOAD_LIST_SILENT_COMPLETE",

     DATA_UPLOAD_ADD_REQUEST: "DATA_UPLOAD_ADD_REQUEST",
     DATA_UPLOAD_ADD_COMPLETE: "DATA_UPLOAD_ADD_COMPLETE",

     DATA_UPLOAD_SUMMERY_REQUEST: "DATA_UPLOAD_SUMMERY_REQUEST",
     DATA_UPLOAD_SUMMERY_COMPLETE: "DATA_UPLOAD_SUMMERY_COMPLETE",

     DATA_UPLOAD_DATA_PROCESSING_RECORD_REQUEST:
          "DATA_UPLOAD_DATA_PROCESSING_RECORD_REQUEST",
     DATA_UPLOAD_DATA_PROCESSING_RECORD_COMPLETE:
          "DATA_UPLOAD_DATA_PROCESSING_RECORD_COMPLETE",

     DATA_UPLOAD_DATA_DOWNLOAD_SUMMARY_REQUEST:
          "DATA_UPLOAD_DATA_DOWNLOAD_SUMMARY_REQUEST",
     DATA_UPLOAD_DATA_DOWNLOAD_SUMMARY_COMPLETE:
          "DATA_UPLOAD_DATA_DOWNLOAD_SUMMARY_COMPLETE",

     DATA_FILE_TYPE_LIST_REQUEST: "DATA_FILE_TYPE_LIST_REQUEST",
     DATA_FILE_TYPE_LIST_COMPLETE: "DATA_FILE_TYPE_LIST_COMPLETE",

     DATA_FILE_SCHEMA_REQUEST: "DATA_FILE_SCHEMA_REQUEST",
     DATA_FILE_SCHEMA_COMPLETE: "DATA_FILE_SCHEMA_COMPLETE",

     DATA_UPLOAD_RECORD_COUNT_REQUEST: "DATA_UPLOAD_RECORD_COUNT_REQUEST",
     DATA_UPLOAD_RECORD_COUNT_COMPLETE: "DATA_UPLOAD_RECORD_COUNT_COMPLETE",

     DATA_UPLOAD_DOWNLOAD_SCHEMA_TEMP_REQUEST:
          "DATA_UPLOAD_DOWNLOAD_SCHEMA_TEMP_REQUEST",
     DATA_UPLOAD_DOWNLOAD_SCHEMA_TEMP_COMPLETE:
          "DATA_UPLOAD_DOWNLOAD_SCHEMA_TEMP_COMPLETE",

     DATA_UPLOAD_DOWNLOAD_ACTIVE_RECORDS_REQUEST:
          "DATA_UPLOAD_DOWNLOAD_ACTIVE_RECORDS_REQUEST",
     DATA_UPLOAD_DOWNLOAD_ACTIVE_RECORDS_COMPLETE:
          "DATA_UPLOAD_DOWNLOAD_ACTIVE_RECORDS_COMPLETE",

     DATA_UPLOAD_DOWNLOAD_DELETED_RECORDS_REQUEST:
          "DATA_UPLOAD_DOWNLOAD_DELETED_RECORDS_REQUEST",
     DATA_UPLOAD_DOWNLOAD_DELETED_RECORDS_COMPLETE:
          "DATA_UPLOAD_DOWNLOAD_DELETED_RECORDS_COMPLETE",

     DATA_UPLOAD_LIST_REPRESH_REAL_TIME: "DATA_UPLOAD_LIST_REPRESH_REAL_TIME",
};
